<template>
  <div class="relative w-full">
    <div
      class="bg-white text-primary-default px-4 py-2 rounded cursor-pointer flex border border-bdefault overflow-visible"
      @click="isOpen = !isOpen"
    >
      <BuildingOffice2Icon class="mr-1 h-5 w-5" />
      <p class="text-sm text-left truncate overflow-x-hidden ml-2">
        {{ selected?.groupTitle ? `${selected.item.title} - ${selected.groupTitle}` : selected?.item?.title }}
      </p>
      <ChevronDownIcon class="ml-1 h-5 w-5 absolute right-2" />
    </div>
    <div v-if="isOpen" class="absolute mt-2 w-full bg-white rounded shadow-lg z-10">
      <div v-for="(group, gIndex) in normalizedDropdown" :key="gIndex" class="border-b last:border-b-0">
        <div class="px-4 pt-4 text-xs font-bold text-gray-600 uppercase">
          {{ group.groupTitle }}
        </div>
        <div
          v-for="(item, iIndex) in group.items"
          :key="iIndex"
          @click="selectItem(item)"
          :class="[
            group.groupTitle ? 'px-6 pb-2' : 'p-4 border-b border-gray-200 last:border-b-0',
            item.current ? 'bg-gray-100' : '',
            'flex justify-between cursor-pointer rounded text-sm text-pdsPrimaryColor'
          ]"
        >
          <span :class="item.current ? 'font-semibold pt-2' : 'pt-2'">{{ item.title }}</span>
          <span v-if="item.current" class="text-teal-700">
            <CheckIcon
              v-if="item.current"
              :class="['shrink-0', group.groupTitle ? 'h-4 w-4 mt-2' : 'h-5 w-5 self-center ml-2']"
              class="text-pdsPrimaryColor"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { BuildingOffice2Icon, ChevronDownIcon, CheckIcon } from '@heroicons/vue/20/solid';

const normalizedDropdown = computed(() => {
  if (!Array.isArray(props.data)) return [];
  if (props.data[0]?.subGroup) {
    return props.data.map((group) => ({
      groupTitle: group.groupTitle,
      items: group.subGroup.map((item) => ({
        ...item,
        _groupTitle: group.groupTitle
      }))
    }));
  }
  return [
    {
      groupTitle: null,
      items: props.data.map((item) => ({
        ...item,
        _groupTitle: null
      }))
    }
  ];
});
const findSelected = () => {
  for (const group of normalizedDropdown.value) {
    if (group.items && group.items.length > 0) {
      const found = group.items.find((i) => i.current);
      if (found) {
        return { item: found, groupTitle: group.groupTitle || null };
      }
    }
  }
  const firstNonEmptyGroup = props.data.find((g) => g.items && g.items.length > 0);
  if (firstNonEmptyGroup) {
    return {
      item: firstNonEmptyGroup.items[0],
      groupTitle: firstNonEmptyGroup.groupTitle || null
    };
  }
  return { item: null, groupTitle: null };
};
const emit = defineEmits(['update:modelValue', 'change']);
const props = defineProps({
  data: Array,
  modelValue: Object
});
const isOpen = ref(false);
const selectedItem = computed(() => {
  return findSelected();
});
const selected = ref(selectedItem.value);
const selectItem = (item) => {
  normalizedDropdown.value.forEach((group) => {
    const items = group.items || [group];
    items.forEach((i) => (i.current = i.title === item.title));
  });
  selected.value = findSelected(item);
  isOpen.value = false;
  emit('update:modelValue', selected.value);
  emit('change', selected.value);
};
</script>
